import { Button, createDateRange, EButtonType, formatDate, formatPrice, KitIcons, PopOverlay } from '@repo/apg-ui';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ResultsFilter.scss';
import { FormattedMessage, useIntl } from 'react-intl';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { productsActions } from '../../store/products';
import { searchActions } from '../../store/search';
import { AppState } from '../../store';
import { TIMESLOT_OPTIONS } from '../../store/products/constants';
import { TimeslotOverlay } from '../Product/TimeslotOverlay';
import { DurationOverlay } from '../Product/DurationOverlay';
import { PriceOverlay } from '../Product/PriceOverlay';
import { FrequencyOverlay } from '../Product/FrequencyOverlay';
import { CalendarOverlay } from '../Product/CalendarOverlay';
import { UiActions } from '../../store/ui';
import ConfirmationModal from '../Modal/ConfirmationModal';
import { generateCriteria } from '../../utils/payloads';
import { createAvailabilityDates } from '../../utils/calender';

const ResultsFilter = ({
  actionsProduct,
  actionsSearch,
  uiActions,
  products,
  locations,
  loading,
  basket,
  searchParameters,
  searchLocations,
  abortControllers,
}) => {
  const navigate = useNavigate();

  const { budget, dateRanges, duration, spotLength, frequency, timeslot } = locations.searchParameters;

  const [selectedTimeslots, setSelectedTimeslots] = useState<number[]>([timeslot]);
  const [allowedTimeslots, setAllowedTimeslots] = useState<any>([1]);
  const [availability, setAvailability] = useState<any>([]);

  const [selectedDateRanges, setSelectedDateRanges] = React.useState(dateRanges || []);
  const [selectedDuration, setSelectedDuration] = React.useState<number>(duration || 7);
  const [selectedSpotLength, setSelectedSpotLength] = React.useState<number>(spotLength || 10);
  const [selectedFrequency, setSelectedFrequency] = React.useState<string>(frequency || '1:00');
  const [selectedBudget, setSelectedBudget] = React.useState<number>(budget || 0);
  const [resetConfirmation, setResetConfirmation] = React.useState(false);
  const { possibleBookingDates } = products;
  const { startDate, endDate } = dateRanges[0] || {};
  const [budgetFrquencySwitch, setBudgetFrquencySwitch] = useState(true);
  const abortController = useRef(null);

  useEffect(() => {
    if (possibleBookingDates?.startdigital?.date && possibleBookingDates?.end?.date) {
      setAvailability(
        createAvailabilityDates(possibleBookingDates?.startdigital?.date, possibleBookingDates?.end?.date),
      );
    }
  }, [possibleBookingDates]);

  const onBudgetChangeCreateOrUpdateBasket = (parameters: any) => {
    if (basket && basket?.id) {
      actionsProduct
        .updateBasketData({
          basket: basket.id,
          basketreference: basket.reference,
          ...parameters,
        })
        .then(() => {
          actionsProduct
            .updateBasketDefinition({
              basket: basket.id,
              basketreference: basket.reference,
              ...parameters,
            })
            .then(() => {
              actionsProduct.getBasketContent({
                basket: basket.id,
                basketreference: basket.reference,
              });
            });
        });
    } else {
      actionsProduct
        .createBasket({
          branche: null,
          ...parameters,
        })
        .then((result) => {
          if (result?.data?.basket) {
            const basketData = result?.data;
            actionsProduct.getBasketContent({
              basket: basketData?.basket,
              basketreference: basketData?.basketreference,
            });
          }
        });
    }
  };

  const intl = useIntl();

  useEffect(() => {
    if (!possibleBookingDates || !possibleBookingDates?.start) {
      actionsProduct.fetchBookingDates();
    }
    // .then(
    //     (res: {
    //         data: {
    //             length: number;
    //             start: { date: string | number | Date };
    //         };
    //     })
    //     // }) => {
    //     //     if (res.data.length !== 0) {
    //     //         actionsSearch.setSearchParameters({
    //     //             dateRanges: [createDateRange(
    //     //                 new Date(res.data.start.date),
    //     //                 7,
    //     //                 {
    //     //                     toEndOfYear: false,
    //     //                     fullWeeks: true,
    //     //                 },
    //     //             )],
    //     //         });
    //     //     }
    //     // },
    // );
  }, [actionsProduct, actionsSearch]);

  useEffect(() => {
    let targetStartDate =
      startDate ||
      (possibleBookingDates && possibleBookingDates.startdigital && possibleBookingDates.startdigital.date) ||
      new Date();
    const range = createDateRange(new Date(targetStartDate), duration, {
      toEndOfYear: duration > 21,
      fullWeeks: false,
    });
    setSelectedDateRanges([
      {
        range: [range],
        duration: duration,
        startDate: range.startDate,
        endDate: range.endDate,
      },
    ]);
    updateAllowedTimeslots(duration);
  }, [possibleBookingDates]);

  useEffect(() => {
    fetchProducts();
  }, [searchParameters?.timeslot, searchParameters?.spotLength, searchParameters?.dateRanges]);

  useEffect(() => {
    const defination = basket?.basketProducts?.definition;
    if (defination && defination?.budget) {
      setSelectedBudget(defination?.budget);
    } else {
      setSelectedBudget(budget || 0);
    }

    if (defination && defination?.frequency) {
      setSelectedFrequency(defination?.frequency);
    } else {
      setSelectedFrequency(frequency || '1:00');
    }
  }, [basket?.basketProducts?.definition]);

  const updateAllowedTimeslots = (_duration: number) => {
    let newAllowedTimeslots = [];
    if (_duration % 7 === 0 || _duration > 7) {
      for (let slot of TIMESLOT_OPTIONS) {
        newAllowedTimeslots.push(slot.timeslot);
      }
    } else {
      newAllowedTimeslots.push(1);
      setSelectedTimeslots([1]);
      actionsSearch.setSearchParameters({ timeslot: 1 });
    }
    setAllowedTimeslots(newAllowedTimeslots);
  };

  const generatePostPayload = (mapPotentialCoordinates?) => {
    const result = {
      sort: [
        {
          column: searchParameters.currentSort,
          direction: searchParameters.sort[searchParameters.currentSort],
        },
      ],
      group: ['format', 'subformat'],
      criteria: generateCriteria(searchLocations, searchParameters),
    };
    if (mapPotentialCoordinates) {
      result['mapview'] = mapPotentialCoordinates;
    }
    return result;
  };

  const fetchProducts = () => {
    if (loading.productList && abortControllers.length > 0) {
      abortControllers.forEach((controller) => {
        controller.abort();
        uiActions.setLoading('productList', true);
      });
    }
    if (abortController.current) {
      abortController.current.abort();
    }
    abortController.current = new AbortController();
    actionsProduct.addAbortController(abortController.current);
    uiActions.setLoading('productList', true);
    actionsProduct.postSelect(generatePostPayload(), abortController.current.signal).then((res) => {
      if (res === 'Aborting') {
        // That means some other fetch is in progress
        return;
      }
      uiActions.setLoading('productList', false);
    });
  };

  const onTimeslotFilterChange = (option, value) => {
    setSelectedTimeslots([option]);

    actionsSearch.setSearchParameters({ timeslot: option });
  };

  const getSelectedTimeslotName = () => {
    const selectedTimeSlot = TIMESLOT_OPTIONS.filter((option) => selectedTimeslots.includes(option.timeslot));
    return selectedTimeSlot.length ? selectedTimeSlot[0]?.title : '-';
  };

  const handleDateChange = (newDateRanges) => {
    setSelectedDateRanges(newDateRanges);
    setSelectedDuration(newDateRanges[0].duration);

    updateAllowedTimeslots(newDateRanges[0].duration);

    actionsSearch.setSearchParameters({
      dateRanges: newDateRanges[0].range,
      duration: newDateRanges[0].duration,
    });
    document.body.click();
  };

  const isSpotLengthValid = (sl: string) => {
    return parseInt(sl) >= 10;
  };

  return (
    <>
      <div className='d-flex'>
        <table className='filterpill-table'>
          <tr className='filterpill'>
            <td className='filterpill-cell filterpill-dates'>
              <PopOverlay
                className='filterpill-padding dates'
                content={
                  <CalendarOverlay
                    getAvailabilityForDigitalProduct={() => {}}
                    producturn={''}
                    productAvailability={availability}
                    possibleBookingDates={possibleBookingDates}
                    dateRanges={selectedDateRanges}
                    handleDateChange={handleDateChange}
                    spotlength={spotLength}
                    timeslots={selectedTimeslots}
                    setLoading={(key, value) => uiActions.setLoading(key, value)}
                    isLoading={loading.isCalendarLoading}
                  />
                }
              >
                <div className='filterpill-tabs bg-white'>
                  <div className='slot selected d-flex flex-row'>
                    <KitIcons.CalIcon />
                    <div className='d-flex flex-column'>
                      <div className='filterpill-subheading'>
                        {formatDate(selectedDateRanges[0]?.startDate, 'dd.MM.yyyy', intl.locale)} -{' '}
                        {formatDate(selectedDateRanges[0]?.endDate, 'dd.MM.yyyy', intl.locale)}
                      </div>
                      <div className='filterpill-heading'>
                        {selectedDateRanges[0]?.duration || selectedDuration}{' '}
                        <FormattedMessage id='ec.checkout.days' defaultMessage='Tag(e)' />
                      </div>
                    </div>
                  </div>
                </div>
              </PopOverlay>
            </td>
            <td className='filterpill-cell filterpill-timeslot'>
              <PopOverlay
                className='filterpill-padding timeslot'
                content={
                  <TimeslotOverlay
                    options={TIMESLOT_OPTIONS}
                    selectedTimeslot={selectedTimeslots}
                    onSelectionChange={onTimeslotFilterChange}
                    allowedTimeslots={allowedTimeslots}
                  />
                }
              >
                <div className='filterpill-tabs bg-white'>
                  <div className='slot selected d-flex flex-row'>
                    <KitIcons.TargetIcon />
                    <div className='d-flex flex-column pl-1'>
                      <div className='filterpill-subheading'>
                        <FormattedMessage id='ec.checkout.timeslot' defaultMessage='Zeitfenster' />
                      </div>
                      <div className='filterpill-heading text-wrap'>{getSelectedTimeslotName()}</div>
                    </div>
                  </div>
                </div>
              </PopOverlay>
            </td>
            <td className='filterpill-cell filterpill-duration'>
              <PopOverlay
                className='filterpill-padding duration'
                content={
                  <DurationOverlay
                    durationLabels={intl.formatMessage({
                      id: 'ec.checkout.sekunden',
                      defaultMessage: 'Sekunden',
                    })}
                    placeholderText={intl.formatMessage({
                      id: 'ec.checkout.sekunden',
                      defaultMessage: 'Sekunden',
                    })}
                    inputValue={selectedSpotLength}
                    onChange={(value) => {
                      setSelectedSpotLength(value);
                      document.body.click();
                      actionsSearch.setSearchParameters({
                        spotLength: value,
                      });
                    }}
                  />
                }
              >
                <div className='filterpill-tabs bg-white'>
                  <div className='slot selected d-flex flex-row'>
                    <KitIcons.TimeIcon />
                    <div className='d-flex flex-column pl-1'>
                      <div className='filterpill-subheading'>
                        <FormattedMessage id='ec.checkout.duration' defaultMessage='Spotlänge' />
                      </div>
                      <div className='filterpill-heading'>
                        {!isSpotLengthValid(spotLength) || !spotLength ? (
                          <FormattedMessage id='ec.checkout.fromTen' defaultMessage='Ab 10' />
                        ) : (
                          spotLength
                        )}{' '}
                        <FormattedMessage id='ec.checkout.sekunden' defaultMessage='Sekunden' />
                      </div>
                    </div>
                  </div>
                </div>
              </PopOverlay>
            </td>
            <td className='filterpill-cell d-flex filterpill-budget'>
              <div className='filterpill-padding price flex-column align-items-center justify-content-center'>
                {budgetFrquencySwitch ? (
                  <PopOverlay
                    className='w-100 d-flex align-items-center'
                    content={
                      <PriceOverlay
                        priceLabels={intl.formatMessage({
                          id: 'ec.modals.resultList.columnTitles.price',
                          defaultMessage: 'Price',
                        })}
                        placeholderText={intl.formatMessage({
                          id: 'ec.modals.resultList.columnTitles.price',
                          defaultMessage: 'Price',
                        })}
                        inputValue={selectedBudget}
                        onChange={(value) => {
                          setSelectedBudget(value);
                          document.body.click();
                          const perameters = {
                            budget: value * 1,
                          };
                          setTimeout(() => {
                            actionsSearch.setSearchParameters({
                              ...perameters,
                              frequency: '1:00',
                            });
                            onBudgetChangeCreateOrUpdateBasket(perameters);
                          }, 0);
                        }}
                      />
                    }
                  >
                    <div className='filterpill-tabs bg-white'>
                      <div className='slot selected d-flex flex-row'>
                        <KitIcons.BudgetIcon />
                        <div className='d-flex flex-column pl-1'>
                          <div className='filterpill-subheading'>
                            <FormattedMessage id='ec.checkout.budget' defaultMessage='Budget' />
                          </div>
                          <div className='filterpill-heading'>{formatPrice(selectedBudget)} CHF</div>
                        </div>
                      </div>
                    </div>
                  </PopOverlay>
                ) : (
                  <PopOverlay
                    className='w-100 d-flex align-items-center justify-content-center'
                    content={
                      <FrequencyOverlay
                        frequencyLabels={intl.formatMessage({
                          id: 'ec.checkout.frequency',
                          defaultMessage: 'Frequenz',
                        })}
                        placeholderText={'0:00'}
                        inputValue={selectedFrequency}
                        isFromHeader={true}
                        onChange={(value) => {
                          setSelectedFrequency(value);
                          document.body.click();
                          const perameters = {
                            frequency: value,
                          };
                          setTimeout(() => {
                            actionsSearch.setSearchParameters({
                              ...perameters,
                              budget: 0,
                            });
                            onBudgetChangeCreateOrUpdateBasket(perameters);
                          }, 0);
                        }}
                        extraClassName='frequency-overlay-result-filter'
                      />
                    }
                  >
                    <div className='filterpill-tabs bg-white justify-content-center'>
                      <div className='slot selected d-flex flex-row'>
                        <KitIcons.RefreshWhiteIcon />
                        <div className='d-flex flex-column pl-1'>
                          <div className='filterpill-subheading'>
                            <FormattedMessage id='ec.checkout.frequency' defaultMessage='Frequenz' />
                          </div>
                          <div className='filterpill-heading'>
                            {selectedFrequency}
                            {' Min'}
                          </div>
                        </div>
                      </div>
                    </div>
                  </PopOverlay>
                )}
                <div
                  className='filterpill-frequency d-flex flex-row align-items-center cursor-pointer w-100 justify-content-center'
                  onClick={() => setBudgetFrquencySwitch(!budgetFrquencySwitch)}
                >
                  <KitIcons.RefreshIcon />
                  <span>
                    {budgetFrquencySwitch ? (
                      <FormattedMessage id='ec.checkout.frequency' defaultMessage='Frequenz' />
                    ) : (
                      <FormattedMessage id='ec.checkout.budget' defaultMessage='Budget' />
                    )}
                  </span>
                </div>
              </div>
            </td>
            <td className='filterpill-cell px-5 filterpill-reset'>
              <Button
                className='pt-0 mt-0'
                buttonType={EButtonType.BasicLink}
                onClick={() => setResetConfirmation(true)}
              >
                <FormattedMessage id='ec.checkout.reset' defaultMessage='RESET' />
              </Button>
            </td>
          </tr>
        </table>
      </div>
      <ConfirmationModal
        title={intl.formatMessage({ id: 'ec.confirmation', defaultMessage: 'Berechnung zurücksetzen' })}
        message={intl.formatMessage({
          id: 'ec.confirmationText',
          defaultMessage: 'Möchten Sie Ihre Berechnung zurücksetzen und neu beginnen?',
        })}
        show={resetConfirmation}
        setHide={() => setResetConfirmation(false)}
        doAction={() => {
          actionsProduct.resetAllProducts();
          actionsSearch.resetAllSearch();
          actionsProduct.deselectAllProductsAndGroups();
          actionsProduct.clearFilteredProducts();
          actionsProduct.clearFilteredProductsByType();
          uiActions.setIsBatchSelect(false);
          navigate('/');
        }}
        confirmationButton='Reset'
      />
    </>
  );
};

function mapStateToProps(state: AppState) {
  return {
    products: state.products,
    locations: state.locations,
    searchParameters: state.locations.searchParameters,
    searchLocations: state.locations.searchLocations,
    abortControllers: state.products.abortControllers,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    actionsProduct: bindActionCreators(productsActions as any, dispatch),
    actionsSearch: bindActionCreators(searchActions as any, dispatch),
    uiActions: bindActionCreators(UiActions as any, dispatch),
    dispatch: dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ResultsFilter);
